import React, { useState } from "react";
import TextInput from "../../Atoms/Inputs/TextInput";
import Buttons from "../../Atoms/Buttons/Buttons";
import styles from "./LogInForm.module.css";
import { Formik, Form } from "formik";
import passicon from "../../../assets/Imagess/PasswordIcon.svg";
import emailicon from "../../../assets/Imagess/UsernameIcon.svg";
import LoginValidationSchema from "../../../ValidationSchema/LoginValidationSchema";
import { useLogin } from "../../../Hooks/Authentication";
import { toast } from "react-toastify";
import LoaderButton from "../Loader/LoaderButton";
import { saveSession } from "../../../services/session";
import { landingPath } from "../../../services/pageAccess";

const LogInForm = ({ setShowForgot }) => {
  const [, setError] = useState(false);
  const { mutate: login, isLoading: isLoginLoading } = useLogin();
  const initialValues = {
    username: "",
    password: "",
  };

  const handleLoginSubmit = (values) => {
    login(values, {
      onSuccess: (response) => {
        let session;
        try {
          session = saveSession(response);
        } catch (_error) {
          toast.error("Invalid login response");
          setError(true);
          return;
        }

        /**
         * WHERE THE OPERATOR LANDS.
         *
         * This used to read `cmsPages[0]`, falling back to its first child.
         * Three rows in the live menu are GROUP HEADINGS with an empty route,
         * so a user whose first row was one of them - and no nested children on
         * that row - was sent to `/home`, which redirected to itself forever.
         * `landingPath` walks the whole tree, skips the headings, and returns
         * the no-permission screen when there is genuinely nothing to open.
         *
         * `window.location.href`, not `navigate()`, is LOAD-BEARING: the token
         * has only just been written, and a full reload is what makes the rest
         * of the app pick it up. The 500 ms wait is not - `localStorage` is
         * synchronous - but it is left alone here; removing it belongs with the
         * header fix, not with this change.
         */
        setTimeout(() => {
          window.location.href = landingPath(session?.cmsPages);
        }, 500);
      },
      onError: (error) => {
        toast.error("Invalid Credentials");
        setError(true);
      },
    });
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={LoginValidationSchema}
        onSubmit={(values) => {
          handleLoginSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => {
          return (
            <Form>
              <div className={styles["form-container"]}>
                <TextInput
                  icon={emailicon}
                  width="100%"
                  label="Username"
                  placeholder="Enter Username"
                  specialClassName="loginInput"
                  name="username"
                  value={values.username}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.username}
                  touched={touched.username}
                  titleColor="#FFF"
                  inputColor="#FFF"
                  inputBackground="transparent"
                  borderColor="#FFF"
                  labelColor="#fff"
                />
                <TextInput
                  icon={passicon}
                  width="100%"
                  label="Password"
                  placeholder="Enter Password"
                  specialClassName="loginInput"
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  errors={errors.password}
                  touched={touched.password}
                  titleColor="#FFF"
                  inputColor="#FFF"
                  inputBackground="transparent"
                  borderColor="#FFF"
                  labelColor="#fff"
                />
                {isLoginLoading ? (
                  <LoaderButton />
                ) : (
                  <Buttons
                    text="Login"
                    width="100%"
                    handleOnClick={handleSubmit}
                    type="submit"
                    rounded
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid #FFF",
                      fontFamily: "BukraBold",
                      fontSize: "20px",
                    }}
                  />
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      {/* 
      <label
        className={`${styles["forgotPassword"]}`}
        onClick={() => setShowForgot(true)}
      >
        {"Forgot Password?"}
      </label> */}
    </>
  );
};

export default LogInForm;
